/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable @next/next/no-img-element */
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import Image from 'next/image';
import { TopcoImg, FitType, Badge } from '@src/container/component/common';
import { RankingGroup } from '@src/pageModels/HomeViewModel';
import { RankColor } from '@src/container/component/top100/view/index';
import Link from 'next/link';
import _ from 'lodash';

export interface RankComicAtomProps extends RankingGroup {
  index: number;
}

const RankComicAtom = (props: RankComicAtomProps) => {
  const { index } = props;

  return (
    <li className="rank-item" css={tempCss}>
      <Link prefetch={false} href={`/comic/${props.comicId}`} passHref>
        <a>
          <div className="thumbbox thumb_loading">
            {/* <TopcoImg src={props.imgPath} alt={props.tit} fit={FitType.FILL} /> */}
            <Image
              src={props.imgPath}
              layout="fill"
              objectFit="cover"
              alt={props.tit}
            />
          </div>

          <div className="rank_info">
            <p className="thumb_tit">
              <RankingLabel className={`txtico_rank`} color={RankColor(index)}>
                {props.rank}
              </RankingLabel>

              {/*{console.log('badge',props.badge.includes('NEW'))}*/}
              {props.badge.includes('NEW') && (
                <Badge type={'new'} className="mr2" height="13px" />
              )}
              {props.badge.includes('UP') && (
                <Badge type={'up'} className="mr2" height="13px" />
              )}

              <span className="txtico_title">{props.tit}</span>
            </p>
            <p className="thumb_author">
              <span className="tit_thumb_a">
                {props.authors.join(' & ') ?? ''}
              </span>
            </p>

            {/* TODO: 단위 수정 */}
            <p className="thumb_info">
              <span className="viewCount">
                <img
                  title="badge"
                  className="ico_view"
                  src="/images/svg/ico_view.svg"
                />
                <span className="viewCountTxt">{props.viewCount} Views</span>
              </span>
            </p>
          </div>
        </a>
      </Link>
    </li>
  );
};

export default RankComicAtom;

export const RankingLabel = styled.span((props: { color: string }) => ({
  color: props.color,
}));

const tempCss = css`
  &:after {
    content: '';
    visibility: hidden;
    display: block;
    height: 0;
    clear: both;
  }

  & a {
    display: flex;
    align-items: center;

    /* 썸네일  */
    & .thumbbox {
      width: 100px;
      height: 140px;
      float: left;
      background-size: cover;
      padding-bottom: 0;
      position: relative;
      image-rendering: auto;
      flex: none;
      background-color: #eee;

      &:before {
        position: absolute;
        content: '';
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        border: 1px solid rgba(0, 0, 0, 0.1);
        display: block;
        z-index: 1;
        -ms-box-sizing: border-box;
        -o-box-sizing: border-box;
        box-sizing: border-box;
      }
    }
    /* 썸네일  */

    /* 코믹정보 */
    & .rank_info {
      letter-spacing: -0.3px;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      width: calc(100% - 100px);
      padding-left: 0.75rem;

      /* title */
      & .thumb_tit {
        font-size: 0.8rem;
        letter-spacing: -0.4px;
        color: #000;
        font-weight: 500;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: flex-start;
        align-items: center;
        width: 100%;

        & span {
          vertical-align: top;
          line-height: 100%;

          &.txtico_rank {
            display: inline-block;
            /* color: #333; */
            text-align: center;
            font-size: 25px;
            margin-right: 6px;
            font-weight: 600;
            font-family: 'roboto';
            letter-spacing: -0.2px;
            padding: 1px 0;

            &.rank_1 {
              color: #e7bb5c;
            }

            &.rank_2 {
              color: #aeb1bb;
            }

            &.rank_3 {
              color: #d28d72;
            }
          }

          &.txtico_title {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            vertical-align: top;
            font-size: 0.825rem;
            font-weight: 500;
            padding: 1px 0;
            align-items: center;
            width: 100%;
            display: inline-block;
            margin-top: -3px;
          }
        }
      }
      /* title */

      /* author */
      & .thumb_author {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-top: -2px;
        font-size: 0.6875rem;
        color: #666;
        width: 100%;

        & span {
          vertical-align: middle;
          display: inline-block;

          &.tit_thumb_a {
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            text-align: left;
            line-height: 15px;
            height: 16px;
            max-width: 98%;
          }
        }
      }
      /* author */

      /* thumbInfo */
      & .thumb_info {
        margin-top: 20px;

        & .viewCount {
          float: left;
          align-items: center;
          display: flex;
          margin-right: 4px;
          overflow: hidden;

          & .ico_view {
            height: 0.4rem;
            display: inline-block;
            float: left;
            margin-right: 2px;
            margin-top: -2px;
          }

          & .viewCountTxt {
            display: inline-block;
            flex: auto;
            flex-shrink: 0;
            font-family: 'roboto';
            font-size: 0.6rem;
          }
        }
      }
      /* thumbInfo */
    }
    /* 코믹정보 */
  }
`;
